export const ID_TOKEN_KEY = "user_token";
import routeTenant, { getTenantCurrent } from "@/core/services/routeTenant.service";
import router from "@/router/index";
import store from "@/core/services/store";


export const getKeyToken = () => {
  const answer_id = router.currentRoute.params.answer_id
  const user_id = store?.getters.currentUser.id

  if (answer_id) {
    return ID_TOKEN_KEY + '_' + answer_id
  } else if (user_id) {
    return ID_TOKEN_KEY + '_' + user_id;
  }
  // let tenant = routeTenant.getTenantCurrent();
  // if (tenant){
  //   return ID_TOKEN_KEY+'_'+tenant;
  // }
};

export const getToken = (token) => {
  const answer_id = router.currentRoute.params.answer_id
  const user_id = store?.getters.currentUser.id
  let keyToken = ID_TOKEN_KEY;
  if (answer_id) {
    keyToken = ID_TOKEN_KEY + '_' + answer_id
  } else if (user_id) {
    keyToken = ID_TOKEN_KEY + '_' + user_id;
  }
  return window.localStorage.getItem(token ? token : keyToken);
};

export const saveToken = token => {
  const answer_id = router.currentRoute.params.answer_id
  const user_id = store?.getters.currentUser.id
  let keyToken = ID_TOKEN_KEY;
  if (answer_id) {
    keyToken = ID_TOKEN_KEY + '_' + answer_id
  } else if (user_id) {
    keyToken = ID_TOKEN_KEY + '_' + user_id;
  }

  window.localStorage.setItem(keyToken, token);
};

export const destroyToken = () => {
  const answer_id = router.currentRoute.params.answer_id
  const user_id = store?.getters.currentUser.id
  let keyToken = ID_TOKEN_KEY;
  if (answer_id) {
    keyToken = ID_TOKEN_KEY + '_' + answer_id
  } else if (user_id) {
    keyToken = ID_TOKEN_KEY + '_' + user_id;
  }
  window.localStorage.removeItem(keyToken);
};

export default { getToken, saveToken, destroyToken, ID_TOKEN_KEY };
